import styled from 'styled-components';
import { motion } from 'framer-motion';

export const PageNavBar = styled.header`
    align-items: center;
    display: flex;
    gap: 16px 32px;
    justify-content: space-between;
    margin: 0 auto;
    max-width: 1184px;
    width: 100%;

    @media (max-width: 640px) {
        align-items: flex-start;
        flex-direction: column;
    }
`;

export const LogoLink = styled.button`
    background: none;
    border: 0;
    cursor: pointer;
    flex: none;
    padding: 0;

    img {
        display: block;
        height: 48px;
        transition: transform 0.3s ease-in-out;
    }

    &:hover img {
        transform: scale(1.025);
    }

    &:focus-visible {
        outline: 1px solid rgba(255, 255, 255, 0.6);
        outline-offset: 4px;
    }

    @media (max-width: 640px) {
        img {
            height: 40px;
        }
    }
`;

export const NavLinks = styled.nav`
    display: flex;
    flex-wrap: wrap;
    gap: 28px;
    justify-content: flex-end;
    min-width: 0;

    @media (max-width: 640px) {
        justify-content: flex-start;
    }

    @media (max-width: 400px) {
        gap: 18px;
    }
`;

export const NavLink = styled(motion.button)`
    background: none;
    border: 0;
    color: #ffffff;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    line-height: 1;
    opacity: ${({ $active }) => ($active ? 1 : 0.72)};
    padding: 8px 0;
    position: relative;
    text-transform: uppercase;
    transition: opacity 0.2s ease;
    white-space: nowrap;

    &:hover {
        opacity: 1;
    }

    &:focus-visible {
        outline: 1px solid rgba(255, 255, 255, 0.6);
        outline-offset: 4px;
    }
`;

export const NavUnderline = styled(motion.span)`
    background: #ffffff;
    bottom: 2px;
    height: 1px;
    left: 0;
    pointer-events: none;
    position: absolute;
    transform-origin: center;
    width: 100%;
`;
